import inView from 'element-in-view';
import defer from 'lodash/defer';

export default class Scroller {
  constructor() {
    this.$blades = document.querySelectorAll('[data-blade]');
    this.$header = document.querySelector('.c-header');
    this.activeClass = 'is-active';
    this.minScroll = 0;
    this.viewportOptions = {
      threshold: 0.5,
    };

    // Scroll by 400px before hiding the header on desktop
    if (window.innerWidth > 1024) {
      this.minScroll = 400;
    } else if (document.body.classList.contains('page-template-template--home')) {
      // Special min scroll rule rule for homepage header
      this.minScroll = (5 * 16) * 2;
    }

    this.enterEvent = new CustomEvent('seatfrog.onBladeEnter', {
      detail: { enter: true },
    });

    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  /**
   * @function onScroll
   * Fired on window scroll
   */
  onScroll() {
    const scrollPos = window.pageYOffset;

    if (scrollPos === 0) {
      this.$header.classList.remove('is-scrolling-down');
      this.$header.classList.remove('is-scrolling-up');
      this.$header.classList.remove('is-scrolling');
      return;
    }

    this.$header.classList.add('is-scrolling');
    
    if (scrollPos <= this.minScroll) {
      return;
    }

    if (this.prevScroll > scrollPos) {
      this.$header.classList.add('is-scrolling-up');
      this.$header.classList.remove('is-scrolling-down');
    } else {
      this.$header.classList.add('is-scrolling-down');
      this.$header.classList.remove('is-scrolling-up');
    }

    this.prevScroll = scrollPos;

    this.$blades.forEach((blade) => {
      if (blade.dataset.threshold) {
        this.viewportOptions.threshold = parseFloat(blade.dataset.threshold);
      }

      // The blade has entered
      if (inView(blade, this.viewportOptions)) {
        blade.classList.add(this.activeClass);

        // Dispatch the enter event once
        // This is so animations don't fire twice
        if (!blade.dataset.dispatched) {
          blade.dispatchEvent(this.enterEvent);

          defer(() => {
            blade.dataset.dispatched = true;
          });
        }
      } else {
        // The blade has left
        blade.classList.remove(this.activeClass);
      }
    });
  }
}
